import React from "react";
import { cardCls, labelCls } from "./tokens";

/**
 * EmptyState — centered icon + headline + helper + optional CTA.
 * variant: "no-data" | "no-results" | "action-required"
 */
export default function EmptyState({
  Icon,
  title,
  description,
  action,
  variant = "no-data",
  testId,
}) {
  const tid =
    testId || `empty-state-${variant}`;

  return (
    <div
      data-testid={tid}
      className={`${cardCls} flex flex-col items-center justify-center text-center gap-4 p-8`}
    >
      {Icon && (
        <span
          className={`inline-flex h-16 w-16 items-center justify-center rounded-od-input ${
            variant === "action-required"
              ? "bg-onedesk-warning/10"
              : "bg-onedesk-bg"
          } border border-onedesk-border`}
        >
          <Icon
            className={`h-7 w-7 ${
              variant === "action-required"
                ? "text-onedesk-warning"
                : "text-onedesk-textSecondary"
            }`}
            strokeWidth={2}
          />
        </span>
      )}
      <div className="flex flex-col gap-2 max-w-md">
        <span className={labelCls}>
          {variant === "no-results" ? "No Matches" :
           variant === "action-required" ? "Action Required" : "Nothing Here Yet"}
        </span>
        <h3 className="font-bold text-lg text-onedesk-textPrimary">
          {title}
        </h3>
        {description && (
          <p className="font-medium text-sm text-onedesk-textSecondary leading-relaxed">
            {description}
          </p>
        )}
      </div>
      {action && <div className="pt-2">{action}</div>}
    </div>
  );
}
